import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import TasksView from 'components/tasks/TasksView';
import BasePage from 'components/UI/BasePage';
import { setPaneContent } from 'services/pane/slice';
import links from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const TasksPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('tasks')}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { label: t('tasks') },
          ]}
        />
        <h4>{t('tasks')}</h4>
        <TasksView
          onTaskClick={
            taskId => dispatch(
              setPaneContent({
                type: 'TASK',
                id: taskId,
              })
            )
          }
          paginated
          showAddButton
          showCompletionFilter
          showDueDateFilter
          showViewModeButtons
        />
      </BasePage>
    </>
  );
};

export default TasksPage;
